(function () {
  var eventName = 'quantity-selector:update';
  var squareCoverStyleId = 'ab-product-card-square-cover-style';

  function installSquareCoverStyle() {
    if (document.getElementById(squareCoverStyleId)) return;

    var style = document.createElement('style');
    style.id = squareCoverStyleId;
    style.textContent = [
      'product-card .card-gallery,',
      'product-card .card-gallery slideshow-component,',
      'product-card .card-gallery slideshow-container,',
      'product-card .card-gallery slideshow-slides,',
      'product-card .card-gallery slideshow-slide,',
      'product-card .card-gallery .product-media-container,',
      'product-card .card-gallery .product-media{aspect-ratio:1/1!important;}',
      'product-card .card-gallery .product-media-container.media-fit{--product-media-fit:contain!important;background:#fff!important;}',
      'product-card .card-gallery .product-media-container.media-fit img,',
      'product-card .card-gallery .product-media__image{width:100%!important;height:100%!important;object-fit:contain!important;object-position:center center!important;padding:0!important;background:#fff!important;}',
    ].join('');
    document.head.appendChild(style);
  }

  installSquareCoverStyle();

  function getCartChangeUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_change_url) || '/cart/change.js';
  }

  function getSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
      if (component.dataset.sectionId && ids.indexOf(component.dataset.sectionId) === -1) {
        ids.push(component.dataset.sectionId);
      }
    });
    return ids;
  }

  function setRowRemoving(row) {
    if (!row || row.classList.contains('removing')) return;

    row.style.setProperty('--row-height', row.offsetHeight + 'px');
    row.setAttribute('aria-hidden', 'true');
    row.classList.add('removing');

    row.querySelectorAll('button, input, select, textarea, a').forEach(function (control) {
      if ('disabled' in control) {
        control.disabled = true;
      }
      control.setAttribute('tabindex', '-1');
    });
  }

  function restoreRow(row) {
    if (!row) return;

    row.classList.remove('removing');
    row.removeAttribute('aria-hidden');
    row.style.removeProperty('--row-height');

    row.querySelectorAll('button, input, select, textarea, a').forEach(function (control) {
      if ('disabled' in control) {
        control.disabled = false;
      }
      control.removeAttribute('tabindex');
    });
  }

  function dispatchCartUpdate(cart, sectionId) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: sectionId,
          data: {
            itemCount: cart.item_count,
            source: 'ab-fast-cart-remove',
            sections: cart.sections,
          },
        },
      })
    );
  }

  function getFallbackLine(target, row) {
    var input = target.querySelector?.('input[data-cart-line]') || target.querySelector?.('input');
    var inputLine = Number(input?.dataset?.cartLine);

    if (inputLine > 0) return inputLine;
    if (!row || !row.parentElement) return 0;

    return Array.prototype.indexOf.call(row.parentElement.querySelectorAll('.cart-items__table-row'), row) + 1;
  }

  document.addEventListener(
    eventName,
    function (event) {
      if (!event.detail || event.detail.quantity !== 0) return;
      if (!(event.target instanceof Element)) return;

      var cartItems = event.target.closest('cart-items-component');
      if (!cartItems || !cartItems.dataset.sectionId) return;
      var row = event.target.closest('.cart-items__table-row');
      var line = event.detail.cartLine || getFallbackLine(event.target, row);
      if (!line) return;

      event.stopImmediatePropagation();
      event.preventDefault();

      setRowRemoving(row);

      fetch(getCartChangeUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: 0,
          sections: getSectionIds().join(','),
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          if (cart.errors) {
            restoreRow(row);
            return;
          }

          dispatchCartUpdate(cart, cartItems.dataset.sectionId);
        })
        .catch(function () {
          restoreRow(row);
        });
    },
    true
  );
})();
